import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Dropdown, DropdownButton, Container, Row} from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const NotifAdmin_NewNotifView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [notifAttrs, setNotifAttrs] = useState({
    typeId: '',
    attrs: '',
    msgs: '',
    timeCreated: ''
  });


  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const [notifTypeList,      setNotifTypeList] = useState([]);


  // UI Functions

  // Initialize state
  useEffect(() => {
    fetchNotifTypes();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchNotifTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notif-types");

        resolve(res.data);

        if (   (res.status === 200)
            && (res.data && res.data.length > 0)) {
          setNotifTypeList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const onNotifTypeSelect = (key, event) => {
    setNotifAttrs({ ...notifAttrs, typeId: key })
  };

  const onAttrsInputChange = (e) => {
    setNotifAttrs({ ...notifAttrs, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    validateOtherFields();

    return;
  }

  function validateOtherFields() {
    // Validate form inputs
    if (notifAttrs.typeId === '') {
      setErrMsg(t("I18N_ERR_Need_Notif_type"));
/*
    } else if (notifAttrs.attrs === '') {
      setErrMsg(t("I18N_ERR???"));
    } else if (notifAttrs.msgs === '') {
      setErrMsg(t("I18N_ERR_???"));
*/
    } else {
      setErrMsg('');
      createNewNotif();
    }
  }

  const createNewNotif = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(notifAttrs));

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("notifs", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          props.onUIMode('LIST')
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_notif")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Notif_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Notif_type")}: *</Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!notifAttrs.typeId ? t("common:I18N_DROPDOWN_PROMPT") :
                          (notifTypeList.find( ({ id }) => id === parseInt(notifAttrs.typeId) )).name}
                  onSelect={onNotifTypeSelect}>
                  {notifTypeList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}>
                        {item.name}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={{span: 12}}>{t("I18N_Attr_list")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={{span: 12}}>
                <textarea rows={2} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="attrs"
                          value={notifAttrs.attrs} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={{span: 12}}>{t("I18N_Msg_templates")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={{span: 12}}>
                <textarea rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="msgs"
                          value={notifAttrs.msgs} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default NotifAdmin_NewNotifView;
